import Dexie, { type Table } from "dexie";
import type { FavoriteReport } from "./favorites.types";

class FavoritesDatabase extends Dexie {
  reports!: Table<FavoriteReport, number>;

  constructor() {
    super("AfinaStatisticsFavorites");
    // Keyed by report id; `addedAt` is indexed so the list can be ordered by
    // when each report was favorited.
    this.version(1).stores({
      reports: "id, addedAt",
    });
  }
}

export const favoritesDB = new FavoritesDatabase();
